// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"5fed5925","239":"5f0a965c","453":"422d01d2","732":"8eb8a5cf"}[chunkId] + ".chunk.js";
};